import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

export type State = {
  partnerId: number | null;
};

interface UsePartnerId extends State {
  setPartnerId: (state: Partial<UsePartnerId>) => void;
}

const initialState: State = {
  partnerId: null,
};

export const usePartnerId = create<UsePartnerId>()(
  devtools(set => ({
    ...initialState,
    setPartnerId: args => set({ ...args }),
  })),
);
